import ROLES from './roles';

/**
 * Application Routes
 * Centralized configuration for all application routes.
 */

export const ROUTES = {
    LOGIN: '/login',
    UNAUTHORIZED: '/unauthorized',

    // Content Creator Routes
    DASHBOARD: '/dashboard',
    CONTENT_CREATOR: '/content',
    CONTENT_MAKER: '/maker',
    ACTIVITY_TABLE_UPDATE: '/acttable',
    ACTIVITY_TABLE: '/activity-table',
    MOBILE_TABLES: '/mobile-tables',
    MOBILE_ACTIVITY_TABLES: '/mobile-activity-tables',
    MOBILE_ACTIVITY_TABLE_UPDATE: '/mobile-activity-table-update',
    SCHOOL_TEST_STUDENT: '/school-test-student',
    SLIDE_TRACK_TESTING_SCHOOL: '/slide-track-testing-school',
    SLIDE_TRACK_TESTING_MOBILE: '/slide-track-testing-mobile',
    STUDENT_CHANCE_MANAGEMENT: '/student-chance-management',
    IMAGE_TESTER: '/image-tester',
    TESTER_DASHBOARD: '/tester-dashboard',
    ACTIVITY_PROMPT_MANAGER: '/activity-prompt-manager',
    USER_MANAGEMENT: '/user-management',
    SCHOOL_MANAGEMENT: '/school-management',
    TEST: '/mobile-test',
    SCHOOL_TEST: '/school-test',
    ACTIVITY_SYNC_STATUS: '/activity-sync-status',
  PROJECTOR_ACTIVITIES: '/projector-activities',
  ACTIVITIES: '/activities',
  GRAPH_ACTIVITY: '/graph-activity',
    OFFLINE_ACTIVITY: '/offline-activity',
  TEACHER_ACTIVITY_ASSIGNMENT: '/teacher-activity-assignment',

    // Admin Routes
    ADMIN_DASHBOARD: '/admin',
    ADMIN_ACCESS_CODE: '/admin/access-code',
};

export const ROUTE_CONFIG = [
    {
        path: ROUTES.LOGIN,
        component: 'Login',
        isProtected: false,
    },
    {
        path: ROUTES.UNAUTHORIZED,
        component: 'Unauthorized',
        isProtected: false,
    },
    // Content Creator Routes
    {
        path: ROUTES.DASHBOARD,
        component: 'AIKlassroomDashboard',
        isProtected: true,
        allowedRoles: [ROLES.CONTENT_CREATOR],
    },
    {
        path: ROUTES.CONTENT_CREATOR,
        component: 'AudioDashboard',
        isProtected: true,
        allowedRoles: [ROLES.CONTENT_CREATOR],
    },
    {
        path: ROUTES.CONTENT_MAKER,
        component: 'ContentMaker',
        isProtected: true,
        allowedRoles: [ROLES.CONTENT_CREATOR],
    },
    {
        path: ROUTES.ACTIVITY_TABLE_UPDATE,
        component: 'ActivityTableUpdate',
        isProtected: true,
        allowedRoles: [ROLES.CONTENT_CREATOR],
    },
    {
        path: ROUTES.ACTIVITY_TABLE,
        component: 'ActivityTable',
        isProtected: true,
        allowedRoles: [ROLES.CONTENT_CREATOR],
    },
    {
        path: ROUTES.MOBILE_TABLES,
        component: 'MobileTables',
        isProtected: true,
        allowedRoles: [ROLES.CONTENT_CREATOR],
    },
    {
        path: ROUTES.MOBILE_ACTIVITY_TABLES,
        component: 'MobileActivityTables',
        isProtected: true,
        allowedRoles: [ROLES.CONTENT_CREATOR],
    },
    {
        path: ROUTES.MOBILE_ACTIVITY_TABLE_UPDATE,
        component: 'MobileActivityTableUpdate',
        isProtected: true,
        allowedRoles: [ROLES.CONTENT_CREATOR],
    },
    {
        path: ROUTES.SCHOOL_TEST_STUDENT,
        component: 'SchoolTestStudent',
        isProtected: true,
        allowedRoles: [ROLES.CONTENT_CREATOR],
    },
    {
        path: ROUTES.SLIDE_TRACK_TESTING_SCHOOL,
        component: 'TesterDashboard',
        isProtected: true,
        allowedRoles: [ROLES.CONTENT_CREATOR],
    },
    {
        path: ROUTES.SLIDE_TRACK_TESTING_MOBILE,
        component: 'TesterDashboard',
        isProtected: true,
        allowedRoles: [ROLES.CONTENT_CREATOR],
    },
    {
        path: ROUTES.STUDENT_CHANCE_MANAGEMENT,
        component: 'StudentChanceManagement',
        isProtected: true,
        allowedRoles: [ROLES.CONTENT_CREATOR],
    },
    {
        path: ROUTES.IMAGE_TESTER,
        component: 'ImageTester',
        isProtected: true,
        allowedRoles: [ROLES.CONTENT_CREATOR],
    },
    {
        path: ROUTES.TESTER_DASHBOARD,
        component: 'TesterDashboard',
        isProtected: true,
        allowedRoles: [ROLES.CONTENT_CREATOR],
    },
    {
        path: ROUTES.ACTIVITY_PROMPT_MANAGER,
        component: 'ActivityPromptManager',
        isProtected: true,
        allowedRoles: [ROLES.ADMIN],
    },
    {
        path: ROUTES.USER_MANAGEMENT,
        component: 'UserManagement',
        isProtected: true,
        allowedRoles: [ROLES.ADMIN],
    },
    {
        path: ROUTES.SCHOOL_MANAGEMENT,
        component: 'SchoolManagement',
        isProtected: true,
        allowedRoles: [ROLES.ADMIN],
    },
    {
        path: ROUTES.TEST,
        component: 'MobileTest',
        isProtected: true,
        allowedRoles: [ROLES.CONTENT_CREATOR],
    },
    {
        path: ROUTES.SCHOOL_TEST,
        component: 'SchoolTest',
        isProtected: true,
        allowedRoles: [ROLES.CONTENT_CREATOR],
    },
    {
        path: ROUTES.ACTIVITY_SYNC_STATUS,
        component: 'ActivitySyncStatus',
        isProtected: true,
        allowedRoles: [ROLES.CONTENT_CREATOR],
    },
    {
        path: ROUTES.PROJECTOR_ACTIVITIES,
        component: 'ProjectorActivities',
        isProtected: true,
        allowedRoles: [ROLES.CONTENT_CREATOR],
    },
    {
        path: ROUTES.ACTIVITIES,
        component: 'Activities',
        isProtected: true,
        allowedRoles: [ROLES.CONTENT_CREATOR],
    },
    {
        path: ROUTES.GRAPH_ACTIVITY,
        component: 'GraphActivity',
        isProtected: true,
        allowedRoles: [ROLES.CONTENT_CREATOR],
    },
    {
        path: ROUTES.OFFLINE_ACTIVITY,
        component: 'OfflineActivity',
        isProtected: true,
        allowedRoles: [ROLES.CONTENT_CREATOR],
    },
    {
        path: ROUTES.TEACHER_ACTIVITY_ASSIGNMENT,
        component: 'TeacherActivityAssignment',
        isProtected: true,
        allowedRoles: [ROLES.CONTENT_CREATOR],
    },
    // Admin Routes
    {
        path: ROUTES.ADMIN_DASHBOARD,
        component: 'AdminPage',
        isProtected: true,
        allowedRoles: [ROLES.ADMIN],
    },
    {
        path: ROUTES.ADMIN_ACCESS_CODE,
        component: 'AccessCode',
        isProtected: true,
        allowedRoles: [ROLES.ADMIN],
    },
];
